export default __webpack_public_path__ + "static/media/youtube-call.c4d4caf0.png";